import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-qr-code',
  templateUrl: './qr-code.component.html',
  styleUrls: ['./qr-code.component.css']
})
export class QrCodeComponent implements OnInit {
  qrCodeBase64!: string 
  constructor(private authService: AuthService){}

  ngOnInit(): void {
    this.authService.getUser().subscribe(
      re => {
            this.authService.gtQrCode(re?.sub).subscribe( res => {
      this.qrCodeBase64 = res.result;
      }
      )
      }
    )

  }
  

  downloadQrCode() {
    const link = document.createElement('a');
    link.href = this.qrCodeBase64;
    link.download = 'qr-code.png'; // Nom du fichier à télécharger
    link.click();
  }
  

}
